import { z } from 'zod';

import { getFormatMessage } from './validation-errors';

export const useAccountAddValidation = () => {
	const accountAddSchema = z.object({
		firstName: z.string().trim().min(1),
		middleName: z.string().trim().min(1),
		lastName: z.string().trim().min(1),
		email: z.string().email(getFormatMessage()),
		role: z.string().trim().min(1),
	});

	return { accountAddSchema };
};
export type AccountAddForm = z.infer<ReturnType<typeof useAccountAddValidation>['accountAddSchema']>;
